import { makeStyles } from "@material-ui/core/styles";
import styled from "@emotion/styled";

import { units } from "../../../types/units";
import { withShowIf } from "../../../components/with-show-if/with-show-If.component";

export const useFieldsStyles = makeStyles(() => ({
  fieldWrapper: {
    display: "block",
    "&+ $fieldWrapper": {
      marginTop: "20px",
    },
  },
  centered: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  hidden: {
    display: "none",
  },
}));

export const SubTitle = withShowIf(styled.div`
  position: absolute;
  top: 2rem;
  right: 2rem;
  font-size: 12px;
  ${units({
    color: "grey",
  })}
`);
